module.exports = __webpack_public_path__ + "static/media/humza icons-07.45d7c949.svg";